import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'alg-autoricarica-client-info',
  templateUrl: './alg-autoricarica-client-info.component.html',
  styleUrls: ['./alg-autoricarica-client-info.component.scss']
})
export class AlgAutoricaricaClientInfoComponent implements OnInit {

  @Input() clientInfo: any;
  @Input() isActivationRequest: boolean;

  public generalTextField = {
    label1: 'Il Sig. Nome',
    label2: 'Cognome',
    label3: 'Cod. Fiscale',
    label4: 'Carta Socio Coop n.',
    label5: '(13 cifre),',
    label6:
      'in qualità di socio di Coop Alleanza 3.0 e intestatario di un contratto di fornitura energetica con Accendi luce & gas Coop contraddistinto per:',
    label7: `in qualità di socio di Coop Alleanza 3.0 e intestatario di un contratto di fornitura energetica con Accendi luce & gas Coop`
  };

  constructor() { }

  ngOnInit() {
    console.log('INFO', this.clientInfo)
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-autoricarica-client-info/alg-autoricarica-client-info.component.ts